import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { authorize } from 'utils/auth';
import { INTERNAL_ERROR, BAD_REQUEST } from 'config/constants';
import PaginationOptions from 'utils/domain/PaginationOptions';
import { action, observable, reaction } from 'mobx';
import { FormattedMessage, getMessagesForLocale } from 'ui/i18n';

import { render_date, render_amount, render_po_number } from 'utils';

import {
	SearchBox,
	DataTable,
	InfoBox,
	ConcernMessage,
	Loader,
	ErrorLoadingContent,
	OrderNav,
	WebReportsLink,
} from 'ui/components';

import './SearchPartNumber.scss';

const columns = [
	{
		prop: 'date',
		title: <FormattedMessage id="ordersTable.orderDateColumn" />,
		align: 'center',
		render(row) {
			return render_date(row[this.prop]);
		},
		noWrap: true,
	},
	{
		prop: 'po_number',
		title: <FormattedMessage id="ordersTable.orderReference" />,
		align: 'left',
		render(row) {
			return render_po_number(row[this.prop]);
		},
	},
	{
		prop: 'part',
		title: <FormattedMessage id="ordersTable.partNumberColumn" />,
		align: 'left',
	},
	{
		prop: 'description',
		title: <FormattedMessage id="ordersTable.descriptionColumn" />,
		align: 'left',
	},
	{
		prop: 'ordered_qty',
		title: <FormattedMessage id="ordersTable.orderedQtyColumn" />,
		align: 'right',
	},
	{
		prop: 'est_ship_date',
		title: <FormattedMessage id="ordersTable.estShipColumn" />,
		align: 'center',
		render(row) {
			return render_date(row[this.prop]);
		},
		noWrap: true,
	},
	{
		prop: 'unit_price',
		title: <FormattedMessage id="ordersTable.unitPriceColumn" />,
		align: 'right',
		render(row) {
			return render_amount(row[this.prop]);
		},
		noWrap: true,
	},
	{
		prop: 'extended_price',
		title: <FormattedMessage id="ordersTable.extendedPriceColumn" />,
		align: 'right',
		render(row) {
			return render_amount(row[this.prop]);
		},
		noWrap: true,
	},
];

@authorize({ rights: ['GetPartNumbers'] })
@inject('OrdersState', 'AppState')
@observer
export default class SearchPartNumberPage extends Component {
	static propTypes = {
		AppState: PropTypes.object.isRequired,
		OrdersState: PropTypes.object.isRequired,
	};

	componentWillMount() {
		reaction(
			() => [this.pagination, this.query],
			() => this.OrdersState.fetchPartNumber(this.query, this.pagination)
		);

		reaction(
			() => this.OrdersState.fetchPartNumber.state.result,
			result => this.setTotalCount(result ? result.count : 0)
		);
	}

	componentWillUnmount() {
		this.OrdersState.fetchPartNumber.state.setInPending();
	}

	AppState = this.props.AppState;
	OrdersState = this.props.OrdersState;

	@observable query = '';
	@observable pagination = new PaginationOptions();
	@observable totalCount = null;

	isValidQuery(query) {
		const re = /^([\w\W]{1,30})$/;
		return re.test(query);
	}

	@action
	handleOnSearch(query) {
		this.query = query;
		this.pagination = new PaginationOptions();
	}

	@action
	handlePaginationChange(pagination) {
		this.pagination = pagination;
	}

	@action
	setTotalCount(value) {
		this.totalCount = value;
	}

	render() {
		const { fetchPartNumber } = this.OrdersState;
		const { user, locale } = this.AppState;
		const userCountry = this.props.AppState.user.country.short_name;

		return (
			<div>
				<OrderNav />
				<div className="SearchPartNumber">
					<WebReportsLink />
					<div className="OrderHistory">
						<FormattedMessage id="searchPart.title" />{' '}
						{this.query &&
							`${user.last_name}, ${user.first_name} ${user.middle_name}`}
						{this.totalCount
							? <span>
									- {this.totalCount}{' '}
									<FormattedMessage id="searchPart.itemsFound" />
								</span>
							: null}
					</div>
					<hr />
					<div className="PartNumberLabel">
						<FormattedMessage id="searchPart.searchText" />
					</div>
					<div className="SearchPartNumber__Search row">
						<div className="col-md-4 col-sm-4 col-xs-4">
							<SearchBox
								onSearch={this.handleOnSearch.bind(this)}
								validate={this.isValidQuery}
								placeholder={
									getMessagesForLocale(locale)['searchPart.searchPlaceholder']
								}
								focusSearchInput={true}
								disabled={fetchPartNumber.state.loading}
							/>
						</div>
						{this.totalCount === 0 &&
							<div className="col-md-8 col-sm-8 col-xs-8">
								<InfoBox type="info">
									<FormattedMessage id="searchPart.noOrdersFound" />
								</InfoBox>
							</div>}
					</div>

					<div className="SearchPartNumber__Content">
						{fetchPartNumber.handle({
							loading: () => <Loader />,
							rejected: error =>
								<div>
									{error.status === INTERNAL_ERROR ||
									error.status === BAD_REQUEST
										? <ErrorLoadingContent />
										: <InfoBox type="danger">
												<FormattedMessage id={error.message} />
											</InfoBox>}
								</div>,
							resolved: results =>
								results.items.length
									? <DataTable
											id="SearchPartNumber-results-table"
											columns={columns}
											rows={results.items}
											count={results.count}
											pagination={this.pagination}
											onPaginationChange={this.handlePaginationChange.bind(
												this
											)}
										/>
									: null,
						})}
					</div>
					<ConcernMessage userCountry={userCountry} />
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/pages/SearchPartNumber/index.js